/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useEmailVerifiedMutation } from "../features/apiSlice";
import CustomOverLay from "../components/CustomOverLay";

function EmailVerificationScreen() {
    const location = useLocation();
    const [emailVerified] = useEmailVerifiedMutation();
    const [statusCode, setStatusCode] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (location.pathname.includes("email-address-verification")) {
                const params = new URLSearchParams(location.search);
                const token = decodeURIComponent(params.get("token"));
                const Alteredtoken = token.replace(/ /g, "+");

                const body = {
                    token: Alteredtoken,
                };

                try {
                    const response = await emailVerified({ body });
                    setStatusCode(response);
                } catch (error) {
                    console.error("Error verifying email:", error);
                }
            }
        };

        fetchData();
    }, []);

    return (
        <div className="bg-[#F9F3F5] h-full w-full overflow-x-hidden">
            
            <header className={`bg-[#F9FCFC] w-full py-[25px] shadow-s2 fixed top-0 left-0 z-[9]`}>
                <h1 className={`text-xl font-normal text-[#000] ml-11`}>Email Address Verification</h1>
            </header>
            {statusCode===null ? <>
                <CustomOverLay Active text="Loading ..." classKey={`absolute top-[80px] left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-full h-[calc(100vh-80px)] text-lg`}/>
            </> : <>
                {statusCode?.data?.message === "Email address verified successfully" ? (
                    <div className="bg-[#ffffff] pt-[95px] px-[30px] flex items-center justify-center flex-col h-screen">
                        <span className="w-[75px] h-[75px] bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center">
                            <img src="/images/success_toast.svg" alt="icon" loading="lazy" className="w-[38px] h-[38px]" decoding="async" />
                        </span>
                        <h1 className="mt-5 text-[36px] leading-[42px] font-normal text-[#000000]">Email address verified successfully</h1>
                    </div>
                ) : statusCode?.error?.data?.message === 'Token has expired' ? (
                    <div className="bg-[#ffffff] pt-[95px] px-[30px] flex items-center justify-center flex-col h-screen">
                        <span className="mr-2.5 flex justify-center items-center">
                            <img src="/images/notificationError.svg" alt="icon" loading="lazy" decoding="async" />
                        </span>
                        <h1 className="mt-5 text-[36px] leading-[42px] font-normal text-[#000000]">Oops! It looks like the verification link has expired</h1>
                    </div>
                ) : statusCode?.error?.data?.message === 'Invalid token' ? (
                    <div className="bg-[#ffffff] pt-[95px] px-[30px] flex items-center justify-center flex-col h-screen">
                        <span className="mr-2.5 flex justify-center items-center">
                            <img src="/images/notificationError.svg" alt="icon" loading="lazy" decoding="async" />
                        </span>
                        <h1 className="mt-5 text-[36px] leading-[42px] font-normal text-[#000000]">Invalid email verification link. Please try again or contact support.</h1>
                    </div>
                ) : 
                    <div className="bg-[#ffffff] pt-[95px] px-[30px] flex items-center justify-center flex-col h-screen">
                        <span className="mr-2.5 flex justify-center items-center">
                            <img src="/images/notificationError.svg" alt="icon" loading="lazy" decoding="async" />
                        </span>
                        <h1 className="mt-5 text-[36px] leading-[42px] font-normal text-[#000000]">{statusCode?.error?.data?.message}</h1>
                    </div>
            
                }
            </>}
        </div>
    );
}

export default EmailVerificationScreen;
